var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HighchartComponent',_vm._g({ref:"chartRef",attrs:{"options":_vm.chartOptions,"highcharts":_vm.hc}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }